import React from 'react';
import Carousel from "react-multi-carousel";

const responsive = {
  desktop: {
    breakpoint: { max: 3000, min: 1024 },
    items: 2,
  },
  tablet: {
    breakpoint: { max: 1024, min: 464 },
    items: 1,
  },
  mobile: {
    breakpoint: { max: 464, min: 0 },
    items: 1,
  },
};

const TestimonialComponents = () => {
    return (
  <>
  
     <div className="container-xxl py-5 wow fadeInUp" data-wow-delay="0.1s">
        <div className="container">
          <div className="text-center">
            <h6 className="section-title bg-white text-center text-primary px-3">
              Testimonials
            </h6>
            <h1 className="mb-5">What Our Clients Say</h1>
          </div>

          <Carousel
            responsive={responsive}
            infinite
            autoPlay
            autoPlaySpeed={4500}
            arrows={true}
            showDots={false}
            containerClass="testimonial-carousel mb-5"
            itemClass="px-3 h-200"
          >
            <div className="testimonial-item bg-white text-center border rounded p-4">
              <p className="mb-15">
                Every detail felt intentional from the hotel selection to the flow of
                the itinerary. It was effortless, elevated, and exactly how we like to
                travel.
              </p>
              <div className='mb-1'>★★★★</div>
              <h6 className="mb-0">Chris R</h6>
              <small className="text-muted">International Getaway</small>
            </div>

            <div className="testimonial-item bg-white text-center border rounded p-4">
              <p className="mb-15">
                The level of expertise was immediately clear. Properties, experiences,
                and logistics were perfectly aligned without feeling overplanned.
              </p>
              <div className='mb-1'>★★★★</div>
              <h6 className="mb-0">Valeria M</h6>
              <small className="text-muted">Custom Retreat</small>
            </div>

            <div className="testimonial-item bg-white text-center border rounded p-4">
              <p className="mb-15">
                From negotiation to execution, everything was seamless.
              </p>
              <div className='mb-1'>★★★★</div>
              <h6 className="mb-0">Group Host</h6>
              <small className="text-muted">Curated Experience</small>
            </div>

            <div className="testimonial-item bg-white text-center border rounded p-4">
              <p className="mb-15">
                Thoughtful planning, strong partnerships, and flawless delivery.
              </p>
              <div className='mb-1'>★★★★</div>
              <h6 className="mb-0">Corporate Client</h6>
              <small className="text-muted">Executive Travel</small>
            </div>
          </Carousel>
        </div>
      </div>
  </>
    );
}

export default TestimonialComponents;
